import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN = '[VeranstaltungenModul] GetFunkprotokollVorlagenListeAdmin laden';
export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN_AUSFUEHREN = '[VeranstaltungenModul] GetFunkprotokollVorlagenListeAdmin ausführen';
export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN_ERFOLGREICH = '[VeranstaltungenModul] GetFunkprotokollVorlagenListeAdmin laden erfolgreich';
export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN_FEHLER = '[VeranstaltungenModul] GetFunkprotokollVorlagenListeAdmin Ladefehler';
export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetFunkprotokollVorlagenListeAdmin nicht ausgeführt (evtl. Offline)';


export class GetFunkprotokollVorlagenListeAdminAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlagenListeAdminAusfuehrenAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlagenListeAdminErfolgreichAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN_ERFOLGREICH;
        constructor(public payload: Array<api.FunkprotokollVorlage>, public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlagenListeAdminFehlerAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlagenListeAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryFunkprotokollVorlagenListeAdminActions =
    GetFunkprotokollVorlagenListeAdminAction
    | GetFunkprotokollVorlagenListeAdminAusfuehrenAction
    | GetFunkprotokollVorlagenListeAdminErfolgreichAction
    | GetFunkprotokollVorlagenListeAdminFehlerAction
    | GetFunkprotokollVorlagenListeAdminNichtAusgefuehrtAction
    ;
